export const MAX_IMAGE_UPLOAD_BYTES = 30 * 1024 * 1024;
